<template>
  <v-container>
    <v-divider></v-divider>
    <div class="references caption">
      <v-col cols="12">
        <strong>References</strong>
        <p>
          1. Smith, A. K., Kilaru, V., Klengel, T., Mercer, K. B., Bradley, B.,
          Conneely, K. N., Ressler, K. J., & Binder, E. B. (2015). DNA extracted
          from saliva for methylation studies of psychiatric traits: evidence
          tissue specificity and relatedness to brain.
          <strong>
            <i>Am J Med Genet B Neuropsychiatr Genet</i>
          </strong>, 168B(1), 36-44.
          <a
            href="https://doi.org/10.1002/ajmg.b.32278"
            target="_blank"
            rel="noopener noreferrer"
          >https://doi.org/10.1002/ajmg.b.32278</a>
        </p>
        <p>
          2. Nishitani, S. (2022). Chapter 20: Capturing the Epigenome:
          Differences Among Blood, Saliva, and Brain Samples.
          <strong>
            <i>
              Epigenetics of Stress and Stress Disorders (Editor: Nagy Youssef,
              book)
            </i>
          </strong>, Academic Press, ISBN: 9780128230398.
          <a
            href="https://www.elsevier.com/books/epigenetics-of-stress-and-stress-disorders/youssef/978-0-12-823039-8"
            target="_blank"
            rel="noopener noreferrer"
          >https://www.elsevier.com/books/epigenetics-of-stress-and-stress-disorders/youssef/978-0-12-823039-8</a>
        </p>
        <p>
          3. Hannon, E., Lunnon, K., Schalkwyk, L., & Mill, J. (2015).
          Interindividual methylomic variation across blood, cortex, and
          cerebellum: implications for epigenetic studies of neurological and
          neuropsychiatric phenotypes.
          <strong>
            <i>Epigenetics</i>
          </strong>, 10(11), 1024-1032.
          <a
            href="https://doi.org/10.1080/15592294.2015.1100786"
            target="_blank"
            rel="noopener noreferrer"
          >https://doi.org/10.1080/15592294.2015.1100786</a>
        </p>
        <p>
          4. Edgar, R. D., Jones, M. J., Meaney, M. J., Turecki, G., & Kobor, M.
          S. (2017). BECon: a tool for interpreting DNA methylation findings
          from blood in the context of brain.
          <strong>
            <i>Transl Psychiatry</i>
          </strong>, 7(8), e1187.
          <a
            href="https://doi.org/10.1038/tp.2017.171"
            target="_blank"
            rel="noopener noreferrer"
          >https://doi.org/10.1038/tp.2017.171</a>
        </p>
        <p>
          5. Braun, P. R., Han, S., Hing, B., Nagahama, Y., Gaul, L. N.,
          Heinzman, J. T., Grossbach, A. J., Close, L., Dlouhy, B. J., Howard,
          M. A., Kawasaki, H., Potash, J. B., & Shinozaki, G. (2019).
          Genome-wide DNA methylation comparison between live human brain and
          peripheral tissues within individuals.
          <strong>
            <i>Transl Psychiatry</i>
          </strong>, 9(1), 47.
          <a
            href="https://doi.org/10.1038/s41398-019-0376-y"
            target="_blank"
            rel="noopener noreferrer"
          >https://doi.org/10.1038/s41398-019-0376-y</a>
        </p>
        <p>
          6. Sommerer, Y., Ohlei, O., Dobricic, V., Oakley, D. H., Wesse, T.,
          Sabet, S. S., Demuth, I., Franke, A., Hyman, B. T., Lill, C. M.,
          Bertram, L. (2022). A correlation map of genome-wide DNA methylation
          patterns between paired human brain and buccal samples.
          <strong>
            <i>Clin Epigenetics</i> </strong
          >. 14:139.
          <a
            href="https://doi.org/10.1186/s13148-022-01357-w"
            target="_blank"
            rel="noopener noreferrer"
            >https://doi.org/10.1186/s13148-022-01357-w</a
          >
        </p>
        <p>
          7. Nishitani, S., Isozaki, M., Yao, A., Higashino, Y., Yamauchi, Y.,
          Kidoguchi, M., Kawajiri, S., Tsunetoshi, K., Neish, H., Imoto, H.,
          Arishima H., Kodera, T., Fujisawa, T. X., Nomura, S., Kikuta, K.,
          Shinozaki, G., Tomoda, (2023). A. Cross-tissue correlations of
          genome-wide DNA methylation in Japanese live human brain and blood,
          saliva, and buccal epithelial tissues,
          <strong>
            <i>Transl Psychiatry</i> </strong
          >, 13(1), 72.
          <a
            href="https://doi.org/10.1038/s41398-023-02370-0"
            target="_blank"
            rel="noopener noreferrer"
            >https://doi.org/10.1038/s41398-023-02370-0</a>
        </p>
      </v-col>
    </div>
    <v-footer class="footerInfo" style="display: block;">
      {{ developer }}
      <p class="mb-0">Google Scholar:
        <a
          href="https://scholar.google.com/citations?hl=en&user=GiaWnTcAAAAJ&view_op=list_works"
          target="_blank"
          rel="noopener noreferrer"
        >https://scholar.google.com/citations?hl=en&user=GiaWnTcAAAAJ&view_op=list_works</a>
      </p>
      <p class="mb-0">Research Gate:
        <a
          href="https://www.researchgate.net/profile/Shota-Nishitani"
          target="_blank"
          rel="noopener noreferrer"
        >https://www.researchgate.net/profile/Shota-Nishitani</a>
      </p>
      <p class="mb-0">Website:
        <a
          href="https://sites.google.com/view/snishit/home"
          target="_blank"
          rel="noopener noreferrer"
        >https://sites.google.com/view/snishit/home</a>
      </p>
    </v-footer>
  </v-container>
</template>
<script>
export default {
  name: 'ReferencesFooter',
  data () {
    return {
      developer: `
Shota Nishitani, Ph.D.
Assistant Professor / Lecturer
Research Center for Child Mental Development, University of Fukui, Japan.
Division of Developmental Higher Brain Functions, United Graduate School of Child Development, Osaka University, Kanazawa University, Hamamatsu University School of Medicine, Chiba University, and University of Fukui, Osaka, Japan.
ORCID: 0000-0002-6234-295X`
    }
  }
}
</script>

<style>
div.references p {
  margin: 0.35em 0px;
}
.footerInfo {
  white-space: pre-wrap;
}
</style>
